unable to read source [project]/momira.app/web/node_modules/src/camera/permissions.ts